import TourList from './TourList';

export default TourList;
